import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	Box,
} from "@mui/material";
import { ItemInfo } from "../../models/item";

interface EditItemDialogProps {
	open: boolean;
	item: ItemInfo | null;
	onClose: () => void;
	onSave: (updatedItem: ItemInfo) => void;
}

const EditItemDialog: React.FC<EditItemDialogProps> = ({
	open,
	item,
	onClose,
	onSave,
}) => {
	const [form, setForm] = useState<ItemInfo | null>(item);

	React.useEffect(() => {
		setForm(item);
	}, [item]);

	if (!form) return null;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setForm((prev) =>
			prev
				? {
						...prev,
						[name]:
							name === "minProfitPercent" ||
							name === "purchasePrice" ||
							name === "sellPrice" ||
							name === "availableQuantity"
								? parseFloat(value)
								: value,
				  }
				: prev
		);
	};

	const handleSave = () => {
		if (form) onSave(form);
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>Edit Item</DialogTitle>
			<DialogContent>
				<Box display="flex" flexDirection="column" gap={2}>
					<TextField
						label="Item Name"
						name="name"
						value={form.name}
						onChange={handleChange}
						fullWidth
					/>
					<TextField
						label="Purchase Price"
						name="purchasePrice"
						type="number"
						value={form.purchasePrice}
						onChange={handleChange}
						fullWidth
					/>
					<TextField
						label="Sell Price"
						name="sellPrice"
						type="number"
						value={form.sellPrice}
						onChange={handleChange}
						fullWidth
					/>
					<TextField
						label="Minimum Profit %"
						name="minProfitPercent"
						type="number"
						value={form.minProfitPercent}
						onChange={handleChange}
						fullWidth
					/>
					<TextField
						label="Available Quantity"
						name="availableQuantity"
						type="number"
						value={form.availableQuantity}
						onChange={handleChange}
						fullWidth
					/>
					<TextField
						label="Item Code"
						name="itemCode"
						value={form.itemCode}
						onChange={handleChange}
						fullWidth
						disabled
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button
					onClick={handleSave}
					variant="contained"
					color="primary"
				>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EditItemDialog;
